import { SubstitutionBoardEnumerations } from '../../interfaces/interfaces.module';
import { ProposalListItemModel } from './proposal-list-item-model';
import { utils } from '@bayclubs/utils';

export class SubBoardListItemModel {
    public id: string;
    public clubId: string;
    public clubName: string;
    public clubShortName: string;
    public clubTimezone: string;
    public classId: string;
    public className: string;
    public classCategory: string;
    public classLocation: string;
    public classDate: utils.BcDate;
    public classTimeInMinutesFrom: number;
    public classTimeInMinutesTo: number;
    public instructorFirstName: string;
    public instructorLastName: string;
    public instructorPhotoUrl: string;
    public offersCount: number;
    public status: SubstitutionBoardEnumerations.EnumerationModel;
    public submitterComment: string;
    public substituteFirstName: string;
    public substituteLastName: string;
    public substitutePhotoUrl: string;
    public proposals: ProposalListItemModel[];

    get isOpen(): boolean {
        return this.status.code === SubstitutionBoardEnumerations.SubstitutionRequestStatus.open.code;
    }

    get isClosed(): boolean {
        return this.status.code === SubstitutionBoardEnumerations.SubstitutionRequestStatus.closed.code;
    }

    get isCanceled(): boolean {
        return this.status.code === SubstitutionBoardEnumerations.SubstitutionRequestStatus.cancelled.code;
    }

    get isOverdue(): boolean {
        return this.status.code === SubstitutionBoardEnumerations.SubstitutionRequestStatus.overdue.code;
    }

    public static from(source: {
        id: string;
        clubId: string;
        clubName: string;
        clubShortName: string;
        clubTimezone: string;
        classId: string;
        className: string;
        classCategory: string;
        classLocation: string;
        classDate: utils.BcDate;
        classTimeInMinutesFrom: number;
        classTimeInMinutesTo: number;
        instructorFirstName: string;
        instructorLastName: string;
        instructorPhotoUrl: string;
        offersCount: number;
        status: SubstitutionBoardEnumerations.EnumerationModel;
        submitterComment: string;
        substituteFirstName: string;
        substituteLastName: string;
        substitutePhotoUrl: string;
        proposals: ProposalListItemModel[];
    }): SubBoardListItemModel {
        const obj = new SubBoardListItemModel();
        obj.id = source.id;
        obj.clubId = source.clubId;
        obj.clubName = source.clubName;
        obj.clubShortName = source.clubShortName;
        obj.clubTimezone = source.clubTimezone;
        obj.classId = source.classId;
        obj.className = source.className;
        obj.classCategory = source.classCategory;
        obj.classLocation = source.classLocation;
        obj.classDate = source.classDate;
        obj.classTimeInMinutesFrom = source.classTimeInMinutesFrom;
        obj.classTimeInMinutesTo = source.classTimeInMinutesTo;
        obj.instructorFirstName = source.instructorFirstName;
        obj.instructorLastName = source.instructorLastName;
        obj.instructorPhotoUrl = source.instructorPhotoUrl;
        obj.offersCount = source.offersCount;
        obj.status = source.status;
        obj.submitterComment = source.submitterComment;
        obj.substituteFirstName = source.substituteFirstName;
        obj.substituteLastName = source.substituteLastName;
        obj.substitutePhotoUrl = source.substitutePhotoUrl;
        obj.proposals = source.proposals;

        return obj;
    }
}
